import {HomeIcon} from "@/components/icons";
import {TailSpin} from "@dvrt/graphql-widgets";
import {makeStyles} from "tss-react/mui";
import {useAppSelector} from "@/hooks";

const size = 34;

const useStyles = makeStyles()({
    homeCrumbContainer: {
        width: size,
        height: size,
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    loader: {
        position: "absolute",
        left: 0,
        top: 0,
        opacity: 0,
        transition: "opacity 0.3s",
    },
});

const HomeCrumb = () => {
    const {classes} = useStyles();
    const graphqlQueryIds = useAppSelector((state) => state.graphqlQueryIds);

    return (
        <div className={classes.homeCrumbContainer}>
            <HomeIcon />
            <div className={classes.loader} style={{opacity: graphqlQueryIds.length ? 1 : 0}}>
                <TailSpin height={size} />
            </div>
        </div>
    );
};

export default HomeCrumb;
